import styled from "@emotion/styled";

export const BottomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: var(--card-bg);
	margin-top: 40px;

	max-width: 80%;
	text-align: center;

	.desc-no-padding {
		padding-top: 15px;
		font-size: 16px;
		white-space: pre-wrap;
		padding-right: 30px;

		> a {
			text-decoration: underline;
		}
	}

	.bold {
		font-weight: bold;
	}

	.title {
		font-size: 24px;
		font-weight: 800;
	}

	.sub-title {
		font-size: 16px;
		font-weight: 400;
		white-space: pre-wrap;
	}

	.help {
		font-size: 15px;
		a {
			text-decoration: underline;
			color: var(--primary);
		}
	}

	.btn {
		border-radius: 30px;
		border: 2px solid var(--primary);
		background-color: transparent;
		font-size: 20px;
		font-weight: 700;
		max-width: 450px;
		width: 100%;
		padding: 10px;

		@media screen and (max-width: 768px) {
			font-size: 16px;
		}
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: start;
	position: relative;
`;

export const WrapperContainer = styled.div`
	width: 100%;
	background-color: white;
	border-radius: 30px;
	padding: 40px 40px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

	* {
		white-space: pre-wrap;
		word-break: break-all;
		color: var(--card-bg);
	}

	@media screen and (max-width: 768px) {
		padding: 30px;
		width: 100%;
		border-radius: 10px;
	}

	.detail-title {
		color: var(--card-bg);
		font-size: 27px;
		font-weight: 800;
		line-height: normal;
		white-space: nowrap;
	}

	.center {
		width: 100%;
		text-align: center;
	}

	.channeltalk-link {
		color: var(--primary);
	}

	.subheading {
		font-size: 24px;
		font-weight: bold;
		white-space: pre-wrap;
		padding-bottom: 10px;
		position: relative;
	}

	.guide-link {
		text-decoration: underline;
	}

	.desc {
		font-size: 16px;
		white-space: pre-wrap;
		padding-top: 15px;

		.linkify {
			color: var(--primary);
			cursor: pointer;
		}

		a {
			text-decoration: underline;
		}
	}

	.btn {
		flex: 1;
		font-size: 18px;
		border-radius: 15px;
		font-weight: bold;
	}

	.desc-no-padding {
		padding-top: 15px;
		font-size: 16px;
		white-space: pre-wrap;
		padding-right: 30px;

		> a {
			text-decoration: underline;
		}
	}

	.comment-content-wrapper {
		display: flex;
		flex-direction: column;

		.comment-box {
			background-color: var(--bg-white);
			padding: 10px;

			.comment-title-white-text {
				font-size: 20px;
				font-style: normal;
				font-weight: bold;
				line-height: normal;
				padding: 10px 10px;
				color: var(--card-bg);
			}

			.comment-title {
				font-size: 20px;
				font-style: normal;
				font-weight: bold;
				line-height: normal;
				padding: 10px 20px;
				color: rgb(8, 126, 255);
			}

			.comment-title-start-date {
				font-size: 20px;
				font-style: normal;
				font-weight: bold;
				line-height: normal;
				padding: 10px 20px;
				color: var(--card-bg);
			}

			.comment-contents-white-text {
				font-size: 18px;
				font-style: normal;
				font-weight: bold;
				line-height: normal;
				padding: 10px 10px 5px;
				color: var(--card-bg);
			}

			.comment-contents {
				font-size: 18px;
				font-style: normal;
				font-weight: bold;
				line-height: normal;
				padding: 10px 10px 5px;
				color: rgb(8, 126, 255);
			}

			.comment-item-box {
				margin: 0;
				padding: 10px 20px;
				padding-left: 40px;
			}
		}
	}

	.bold {
		font-weight: bold;
	}

	.desc-list {
		padding-left: 20px;
		margin-top: 0px;
	}

	.subheading-nopadding {
		font-size: 20px;
		font-weight: bold;
		white-space: pre-wrap;
		position: relative;
	}

	.price-title-box {
		display: flex;
		flex-direction: row;
		justify-content: start;
		align-items: baseline;
		flex-wrap: wrap;
		gap: 10px;

		.vat-info {
			font-size: 16px;
			font-weight: 400;
		}
	}

	.payment-info-box {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;

		.guide-info {
			font-size: 14px;
			font-weight: 400;
		}

		.payment-info {
			font-size: 16px;
			font-weight: 400;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}

		.bold {
			font-weight: bold;
		}
	}

	.buttonBox {
		display: flex;
		flex-direction: row;
	}

	.btn {
		flex: 1;
		font-size: 18px;
		border-radius: 15px;
		font-weight: bold;
	}

	.buttonBox > .first {
		margin-right: 15px;
	}

	.onpoint-comment {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: left;

		.onpoint-comment-guide {
			color: var(--primary);
			width: 100%;
			margin-bottom: 10px;
			padding-top: 15px;
		}

		.onpoint-comment-desc {
			width: 100%;
			//
		}

		.white {
			color: white;
		}
	}
`;

export const Line = styled.div`
	width: 100%;
	border: 0.3px solid var(--card-bg);
`;

export const LightLine = styled.div`
	width: 100%;
	border: 0.3px solid #eeeeee;
`;

export const SuperLightLine = styled.div`
	width: 100%;
	border: 0.3px solid #666666;
`;

interface TitleComponentProps {
	title: string;
	subtitle?: string;
	description?: string;
}

export const TitleComponent = (props: TitleComponentProps) => (
	<TitleWrapper>
		<div className="top">
			<div>
				<div id="top-title">{props.title}</div>
				<div id="top-text">{props.subtitle}</div>
				<div className="description">{props.description}</div>
			</div>
			<div>
				<img className="logo" src={"/static/image/logo_white.svg"} />
			</div>
		</div>
	</TitleWrapper>
);

export const TitleComponentWithWhiteBlueLogo = (props: TitleComponentProps) => (
	<TitleWrapper>
		<div className="top">
			<div>
				<div id="top-title">{props.title}</div>
				<div id="top-text">{props.subtitle}</div>
				<div className="description">{props.description}</div>
			</div>
			<div>
				<img
					className="logoImg"
					src={"/onepoint/assets/images/logo/h-logo_bl.png"}
					style={{
						width: "180px",
					}}
				/>
			</div>
		</div>
	</TitleWrapper>
);

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;

	.top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		#top-title {
			color: var(--card-bg);
			font-size: 35px;
			font-weight: 800;
			line-height: normal;
		}

		#top-text {
			margin-top: 8px;
			color: var(--card-bg);
			font-size: 20px;
			font-weight: 600;
			line-height: normal;
		}

		.logo {
			width: 50px;
			height: 50px;
			margin-left: 16px;
		}

		.description {
			//
			font-size: 16px;
			color: #888888;
		}
	}

	.intro {
		margin-top: 36px;
		width: 100%;

		#intro-title {
			color: var(--card-bg);
			font-size: 20px;
			font-weight: 400;
			line-height: normal;
		}

		#intro-data {
			color: var(--card-bg);
			font-size: 16px;
			font-weight: 400;
			margin-top: 14px;
			line-height: 28px;
		}
	}
`;
